import { isEqual } from 'date-fns';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { formatDate, safeParseDate } from 'shared/dates';

type UsePrescribedWildfireFormFieldChangesProps = {
  wildfire: Wildfire;
};

type FormValues = {
  prescribedDateStartLocal: Date | null;
};

type ChangeKey = keyof FormValues;

type ChangeMap = Partial<Record<ChangeKey, string>>;

const areDatesDifferent = (
  dateA: Date | null | undefined,
  dateB: Date | null | undefined,
): boolean => {
  if (!dateA && !dateB) return false;
  if (!dateA || !dateB) return true;
  return !isEqual(dateA, dateB);
};
export const usePrescribedWildfireFormFieldChanges = (
  props: UsePrescribedWildfireFormFieldChangesProps,
): ChangeMap => {
  const { wildfire } = props;
  const { t } = useTranslation();

  const prescribedDateStartLocal = useWatch<FormValues>({
    name: 'prescribedDateStartLocal',
  });

  const initialPrescribedDateStartLocal = safeParseDate(
    wildfire.data.prescribedDateStartLocal,
  );
  const updatedPrescribedDateStartLocal = safeParseDate(
    prescribedDateStartLocal,
  );

  const prescribedDateStartLocalChanged = areDatesDifferent(
    initialPrescribedDateStartLocal,
    updatedPrescribedDateStartLocal,
  );

  const changes: ChangeMap = {};
  if (prescribedDateStartLocalChanged) {
    changes.prescribedDateStartLocal = t(
      'geoEventChangelog.scheduledPublishedDate',
      {
        prevValue: initialPrescribedDateStartLocal
          ? formatDate(initialPrescribedDateStartLocal, 'MM/dd/yyyy h:mm a')
          : t('common.none'),
        newValue: updatedPrescribedDateStartLocal
          ? formatDate(updatedPrescribedDateStartLocal, 'MM/dd/yyyy h:mm a')
          : t('common.none'),
        interpolation: { escapeValue: false },
      },
    );
  }

  return changes;
};
